<template>
<div id="ap_certificaciones">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-top justify-top>
      <v-menu-lateral-apendice />
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Subnivel de Régimen de Operación" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>

            <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;">
              <v-card>
                <v-card-title>
                  <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">
                      {{update ? "edit" : "add"}}
                    </v-icon>&nbsp;
                    <span class="subheading">
                      <strong>
                        {{ update ? "Actualizar" : "Nuevo" }} Subnivel de Régimen de Operación
                      </strong>
                    </span>
                  </v-card>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.native="modal = false" class="close_modal">
                    <v-icon class="white--text">cancel</v-icon>
                  </v-btn>
                </v-card-title>
                <v-form ref="form" lazy-validation>
                  <v-card-text>
                    <v-container grid-list-md text-xs-center @keyup.enter="guardar()">
                      <v-row>
                        <v-col sm="12">
                          <v-text-field label="Clave" type="text" v-model="model.clave" :rules="[rules.required]" maxlength="4"></v-text-field>
                        </v-col>
                        <v-col sm="12">
                          <v-autocomplete v-model="model.id_regimen" :items="regimenes" item-text="text" item-value="id" label="Clave del Régimen de Operación" />
                        </v-col>
                        <v-col sm="12">
                          <v-text-field label="Identificador del caso de Programa" type="text" v-model="model.identificador" maxlength="2"></v-text-field>
                        </v-col>
                        <v-col sm="12">
                          <v-text-field label="Tipo Programa" type="text" v-model="model.nombre" :rules="[rules.required]" maxlength="255"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click.native="modal = false">
                    <v-icon>cancel</v-icon>Cancelar
                  </v-btn>
                  <v-btn color="success" :loading="loading" @click.native="guardar()">
                    <v-icon>done</v-icon>
                    {{ update ? "Actualizar" : "Guardar" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-actions>

          <v-card-text>
            <div id="datagrid">
              <v-client-table ref="principalTable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                </template>

                <template slot="actions" slot-scope="props">
                  <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                    <template v-slot:activator>
                      <v-btn :id="props.row.id" x-small fab dark color="primary">
                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>

                    <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id)
                        " title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id)
                        " title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>

              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-flex>

    </v-layout>
  </v-container>

</div>
</template>

<script>
import axios from "axios";
import menuLateral from "@/views/apendices/MenuLateralApendice.vue";

export default {
  components: {
    "v-menu-lateral-apendice": menuLateral
  },
  mounted() {},

  data: () => ({
    editable: true,
    title: "Subnivel de Régimen de Operación",
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Apéndices",
        disabled: true,
        to: ""
      },
      {
        text: "Subnivel de Régimen de Operación",
        disabled: true,
        to: ""
      }
    ],
    columns: [
      "clave",
      "nombre",
      "identificador",
      "regimen.clave",
      "regimen.identificador",
      "actions"
    ],
    options: {
      headings: {
        "clave": "Clave",
        "nombre": "Tipo Programa",
        "identificador": "Identificador del caso de Programa",
        "regimen.clave": "Clave del Régimen de Operación",
        "regimen.identificador": "Identificador del caso de Régimen",
        "actions": "Operaciones"
      },
    },
    URL: "",
    loading: false,
    modal: false,
    update: false,
    model: {},
    rules: {
      required: v => !!v || "Este campo es requerido",
    },
    items: [],
    regimenes: [],
  }),
  computed: {
    datafiltered() {
      if (this.$refs.principalTable != null) {
        return this.$refs.principalTable.allFilteredData;
      } else {
        return this.items;
      }
    }
  },
  methods: {
    clean_model: function() {
      return {
        id: null,
        clave: null,
        nombre: null,
        identificador: null,
        id_regimen: null
      };
    },
    openModal: function(type) {
      if (type === 1) {
        this.clean_model();
        this.title = "Nuevo Subnivel de Régimen de Operación";
        this.update = false;
      } else {
        this.title = "Actualizar Subnivel de Régimen de Operación";
        this.update = true;
      }
      this.modal = true;
    },
    guardar() {
      const datos = this.model;

      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        var metodo = "post";
        var urlCliente = this.URL;
        if (this.update == true) {
          metodo = "put";
          urlCliente += this.model.id + "/";
        }
        axios({
            method: metodo,
            url: urlCliente,
            data: datos
          })
          .then(res => {
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Los datos se guardaron correctamente",
              footer: ""
            });
            this.cargar();
            this.$root.$dialogLoader.hide();
            this.modal = false;
          })
          .catch(error => {
            try {
              var errores = "";
              if (typeof error.response.data != "undefined") {
                Object.keys(error.response.data).forEach(function(key) {
                  for (var k in error.response.data[key]) {
                    errores += key + ": " + error.response.data[key][k];
                    errores += "<br>";
                  }
                });
              }

              this.$swal({
                position: "center",
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al guardar los datos",
                footer: errores,
                //showConfirmButton: false,
              });
              //console.log(err);
              this.cargar();
              this.$root.$dialogLoader.hide();
              this.modal = false;
            } catch (error) {
              console.log(error);
            }

          });
      }
    },
    cargar: function() {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      axios
        .get(this.URL)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.items = res.data;
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {
          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    getRegistro: function(id_registro) {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      axios
        .get(this.URL + id_registro + "/")
        .then(response => {
          this.model = response.data;
          this.openModal(2); //ACTUALIZAR
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el registro",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    }, //getRegistro
    deleteRegistro: function(id_registro) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
          axios
            .delete(this.URL + id_registro + "/")
            .then(response => {
              this.cargar();
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El registro se eliminó correctamente.",
                footer: ""
              });
            })
            .catch(error => {
              this.$root.$dialogLoader.hide();
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el registro",
                footer: ""
              });
            });
        }

      });
    }, //delete
    cargarRegimenes: function() {
      this.regimenes = [];
      axios
        .post(this.$hostname + "apendices/lista/", {
          "tabla": 34
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            for (var i = 0; i < res.data.length; i++) {
              if (res.data[i].nombre == "TODOS") {
                continue;
              }
              this.regimenes.push({
                "id": res.data[i].id,
                "text": res.data[i].nombre
              });
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los régimenes.",
            footer: ""
          });
          console.log(err);
        });
    }
  }, //methods

  created: function() {
    this.URL = this.$hostname + "catalogos/certificaciones/";
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    if (this.$local_storage.get("id_cliente") > 0) {
      this.editable = false;
      delete this.options.headings["actions"];
      var key = 0;
      for (var k in this.columns) {
        if (this.columns[k] == "actions") key = k;
      }
      if (key > 0) delete this.columns[key];
    }
    this.cargarRegimenes();
    this.cargar();
  }
};
</script>
